module.exports = __webpack_public_path__ + "media/music/synth_chords_2-7255e3d8.mp3";